module.exports = __webpack_public_path__ + "img/ic-dankort-white.bc716750.svg";